module.exports = "https://assets.niwcorp.com/_next/static/images/niw_reversed-a2a9e7995bfdbd01e827a0c89ab7e8ec.png";